import {
  ICreateProfessionPayload,
  ICreateUserPayload,
  IUpdateProfessionPayload,
  IUpdateUserPayload,
  allProfessions,
  allRoles,
  allUsers,
  bulkDeleteProfessions as bulkDeleteProfessionsService,
  bulkDeleteUsers as bulkDeleteService,
  createProfession,
  createUser,
  updateProfession as updateProfessionService,
  updateUser as updateService,
} from "../../services/usersService";
import store from "../store";
import {
  addProfession,
  addUser,
  bulkDeleteProfessions,
  bulkDeleteUsers,
  setProfessions,
  setRoles,
  setUsers,
  updateProfession,
  updateUser,
} from "./reducer";

const { dispatch } = store;

// Admin Actions
export const dispatchAllUsersAction = () => allUsers().then(async (payload) => dispatch(setUsers(payload)));

export const dispatchAllRolesAction = () => allRoles().then(async (payload) => dispatch(setRoles(payload)));

export const dispatchAllProfessionsAction = () =>
  allProfessions().then(async (payload) => dispatch(setProfessions(payload)));

export const dispatchCreateUserAction = (user: ICreateUserPayload) =>
  createUser(user).then(async (payload) => dispatch(addUser(payload)));

export const dispatchBulkDeleteUsersAction = (ids: string[]) =>
  bulkDeleteService(ids).then(async () => dispatch(bulkDeleteUsers(ids)));

export const dispatchBulkDeleteProfessionsAction = (ids: string[]) =>
  bulkDeleteProfessionsService(ids).then(async () => dispatch(bulkDeleteProfessions(ids)));

export const dispatchCreateProfessionAction = (payload: ICreateProfessionPayload) =>
  createProfession(payload).then(async (type) => dispatch(addProfession(type)));

export const dispatchUpdateProfessionAction = (payload: IUpdateProfessionPayload) =>
  updateProfessionService(payload).then(async (type) => dispatch(updateProfession(type)));

export const dispatchUpdateUserAction = (user: IUpdateUserPayload) =>
  updateService(user).then(async (payload) => dispatch(updateUser(payload)));
